import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { GoInStoreWidget as BoltGoInStoreWidget } from '@sainsburys-tech/bolt'
// Use the mockGoInStoreWidget methods for development purpose only - comment for production
import {
  injectGoInStoreScript,
  // generateGoInStoreWidget,
  getMockedBrandingClass
} from '../../../stubs/goInStore/mockGoInStoreWidget'

// Enables development mode as the GIS widget is not available on localhost due to domain not being whitelisted
// Only domain including the argos.co.uk can get the real GIS Widget for now
// Remember to switch it off when deploying to the dev environment
const ENABLE_GIS_DEVELOPMENT_MODE = false
const IS_GIS_DEVELOPMENT_MODE = process?.env?.NODE_ENV === 'development' ? ENABLE_GIS_DEVELOPMENT_MODE : false

/*
 * Brand styles are applied in relation to the productBrand and will be used in production
 * productCategory is only there for UAT2 where the data is not reliable and therefore for testing only; can be removed
 */
const setGoInStoreBranding = (productBrand, productCategory) => {
  let categoryStyleClass = ''

  if (IS_GIS_DEVELOPMENT_MODE) {
    categoryStyleClass = getMockedBrandingClass(productBrand, productCategory)
  } else if (productBrand === 'LG') {
    categoryStyleClass = `gis-enable-product-brand-${productBrand.toLowerCase()}`
  }

  if (document && categoryStyleClass) {
    // Adding the specific brand GoInStore class to the document body
    // as per classes defined in the 'src/javascript/GlobalStyle.js' file
    if (categoryStyleClass.length > 0) document.body.classList.add(categoryStyleClass)
  }
}

const GoInStoreWidget = ({ productBrand, productCategory }) => {
  useEffect(() => {
    // useEffect snippet below is only for development purposes - comment for production if needed
    if (IS_GIS_DEVELOPMENT_MODE) {
      injectGoInStoreScript()
      // @NOTE: Use function bellow for creating the widget HTML structure on the page if you cannot load the GIS script locally when emulating UAT2 locally
      // generateGoInStoreWidget(productBrand === 'LG' ? productBrand : '')
    }
  }, [])

  useEffect(() => {
    setGoInStoreBranding(productBrand, productCategory)
  }, [productBrand, productCategory])

  return (
    <>
      <BoltGoInStoreWidget brand={productBrand} />
    </>
  )
}

GoInStoreWidget.propTypes = {
  productBrand: PropTypes.string,
  productCategory: PropTypes.string
}

export default GoInStoreWidget
